import React from 'react';
import { motion } from 'framer-motion';
const images = [{
  src: 'https://cdn.magicpatterns.com/uploads/keZeVCYP5YhcTFRyB36U7n/img7.jpg',
  alt: 'Modelo con perchero de blazers en verde oliva y rojo',
  label: 'La Colección'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/s1dMYosFGNFTYbMShQ53R6/img3.jpg',
  alt: 'Blazer beige con camisa verde esmeralda',
  label: 'Blazer Clásico'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/s129ZQamccjRH89Z2kDuPS/img4.jpg',
  alt: 'Blazer verde oliva elegante',
  label: 'Verde Oliva'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/viME2pVENoN6iQ4guLQZpR/img5.jpg',
  alt: 'Blazer rojo con camisa blanca',
  label: 'Rojo Pasión'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/3PpewvsuPDZPBeaPBtyAnd/img1.jpg',
  alt: 'Camisa blanca con detalles dorados',
  label: 'Camisa Signature'
}];
export function StyleGallery() {
  return <section className="py-14 md:py-16 bg-cream-100 overflow-hidden" data-id="element-228">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-229">
        {/* Section header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-14 md:mb-20" data-id="element-230">
          <p className="text-xs font-body font-medium tracking-[0.3em] uppercase text-terracotta-400 mb-3" data-id="element-231">
            Nuestra Curaduría
          </p>
          <h2 className="text-3xl md:text-5xl font-display text-charcoal" data-id="element-232">
            Prendas que hablan por ti
          </h2>
        </motion.div>

        {/* Desktop: Asymmetric editorial grid */}
        <div className="hidden md:grid grid-cols-12 gap-4 lg:gap-5" data-id="element-233">
          {/* Left column — tall hero image */}
          <motion.div initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.8,
          ease: [0.25, 0.46, 0.45, 0.94]
        }} className="col-span-5 row-span-2 relative group" data-id="element-234">
            <div className="relative h-full min-h-[680px] overflow-hidden" data-id="element-235">
              <img src={images[0].src} alt={images[0].alt} className="w-full h-full object-cover object-center transition-transform duration-[1.2s] ease-out group-hover:scale-[1.03]" data-id="element-236" />
              <div className="absolute inset-0 bg-gradient-to-t from-charcoal/50 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-237" />
              <div className="absolute bottom-0 left-0 right-0 p-6 translate-y-4 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-500" data-id="element-238">
                <span className="text-xs font-body tracking-[0.2em] uppercase text-cream-100" data-id="element-239">
                  {images[0].label}
                </span>
              </div>
            </div>
          </motion.div>

          {/* Right column — top row: 2 images */}
          <motion.div initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.8,
          delay: 0.15,
          ease: [0.25, 0.46, 0.45, 0.94]
        }} className="col-span-4 relative group" data-id="element-240">
            <div className="relative h-[330px] lg:h-[335px] overflow-hidden" data-id="element-241">
              <img src={images[1].src} alt={images[1].alt} className="w-full h-full object-cover object-top transition-transform duration-[1.2s] ease-out group-hover:scale-[1.03]" data-id="element-242" />
              <div className="absolute inset-0 bg-gradient-to-t from-charcoal/50 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-243" />
              <div className="absolute bottom-0 left-0 right-0 p-5 translate-y-4 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-500" data-id="element-244">
                <span className="text-xs font-body tracking-[0.2em] uppercase text-cream-100" data-id="element-245">
                  {images[1].label}
                </span>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.8,
          delay: 0.3,
          ease: [0.25, 0.46, 0.45, 0.94]
        }} className="col-span-3 relative group" data-id="element-246">
            <div className="relative h-[330px] lg:h-[335px] overflow-hidden" data-id="element-247">
              <img src={images[4].src} alt={images[4].alt} className="w-full h-full object-cover object-top transition-transform duration-[1.2s] ease-out group-hover:scale-[1.03]" data-id="element-248" />
              <div className="absolute inset-0 bg-gradient-to-t from-charcoal/50 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-249" />
              <div className="absolute bottom-0 left-0 right-0 p-5 translate-y-4 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-500" data-id="element-250">
                <span className="text-xs font-body tracking-[0.2em] uppercase text-cream-100" data-id="element-251">
                  {images[4].label}
                </span>
              </div>
            </div>
          </motion.div>

          {/* Right column — bottom row: 2 images */}
          <motion.div initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.8,
          delay: 0.25,
          ease: [0.25, 0.46, 0.45, 0.94]
        }} className="col-span-3 relative group" data-id="element-252">
            <div className="relative h-[330px] lg:h-[335px] overflow-hidden" data-id="element-253">
              <img src={images[2].src} alt={images[2].alt} className="w-full h-full object-cover object-top transition-transform duration-[1.2s] ease-out group-hover:scale-[1.03]" data-id="element-254" />
              <div className="absolute inset-0 bg-gradient-to-t from-charcoal/50 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-255" />
              <div className="absolute bottom-0 left-0 right-0 p-5 translate-y-4 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-500" data-id="element-256">
                <span className="text-xs font-body tracking-[0.2em] uppercase text-cream-100" data-id="element-257">
                  {images[2].label}
                </span>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.8,
          delay: 0.4,
          ease: [0.25, 0.46, 0.45, 0.94]
        }} className="col-span-4 relative group" data-id="element-258">
            <div className="relative h-[330px] lg:h-[335px] overflow-hidden" data-id="element-259">
              <img src={images[3].src} alt={images[3].alt} className="w-full h-full object-cover object-top transition-transform duration-[1.2s] ease-out group-hover:scale-[1.03]" data-id="element-260" />
              <div className="absolute inset-0 bg-gradient-to-t from-charcoal/50 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-261" />
              <div className="absolute bottom-0 left-0 right-0 p-5 translate-y-4 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-500" data-id="element-262">
                <span className="text-xs font-body tracking-[0.2em] uppercase text-cream-100" data-id="element-263">
                  {images[3].label}
                </span>
              </div>
            </div>
          </motion.div>
        </div>

        {/* Mobile: 2-column staggered grid */}
        <div className="grid grid-cols-2 gap-3 md:hidden" data-id="element-264">
          {images.map((img, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.6,
          delay: idx * 0.1,
          ease: [0.25, 0.46, 0.45, 0.94]
        }} className={`relative overflow-hidden ${idx === 0 ? 'col-span-2 h-[320px]' : 'h-[240px]'}`} data-id="element-265">
              <img src={img.src} alt={img.alt} className="w-full h-full object-cover object-top" data-id="element-266" />
              <div className="absolute inset-0 bg-gradient-to-t from-charcoal/40 via-transparent to-transparent" data-id="element-267" />
              <div className="absolute bottom-0 left-0 right-0 p-4" data-id="element-268">
                <span className="text-[0.6rem] font-body tracking-[0.2em] uppercase text-cream-100/90" data-id="element-269">
                  {img.label}
                </span>
              </div>
            </motion.div>)}
        </div>

        {/* Bottom tagline */}
        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.5
      }} className="text-center mt-12 md:mt-16 text-sm text-warm-gray-light tracking-wide font-light italic" data-id="element-270">
          Cada pieza, una declaración. Cada color, una intención.
        </motion.p>
      </div>
    </section>;
}